import type { Catalog } from "./en";

export const de: Catalog = {
  "common.retry": "Erneut versuchen",
  "common.reload": "Neu laden",
  "common.save": "Speichern",
  "common.saving": "Wird gespeichert…",
  "common.saved": "Gespeichert",
  "common.saveFailed": "Speichern fehlgeschlagen",
  "common.saveChanges": "Änderungen speichern",
  "common.delete": "Löschen",
  "common.remove": "Entfernen",
  "common.cancel": "Abbrechen",
  "common.edit": "Bearbeiten",
  "common.openLink": "Öffnen",
  "common.back": "← Zurück",
  "common.loading": "Wird geladen",
  "common.loadingMore": "Wird geladen…",
  "common.sending": "Wird gesendet…",
  "common.error": "Etwas ist schiefgelaufen",
  "common.failed": "Fehlgeschlagen",
  "common.name": "Name",
  "common.email": "E-Mail",
  "common.title": "Titel",
  "common.language": "Sprache",

  "time.now": "jetzt",
  "time.lessThanMinute": "<1 Min.",
  "time.minutes": "{n} Min.",
  "time.hours": "{n} Std.",
  "time.days": "{n} T.",

  "nav.inbox": "Posteingang",
  "nav.faq": "Hilfe-Center",
  "nav.reports": "Berichte",
  "nav.settings": "Einstellungen",
  "layout.workspace": "Workspace",
  "layout.newWorkspace": "+ Neuer Workspace",
  "layout.signOut": "Abmelden",

  "app.unreachable.title": "Server nicht erreichbar",
  "app.unreachable.body": "Prüfe deine Verbindung und versuche es erneut.",
  "app.noWorkspaces.title": "Noch keine Workspaces",
  "app.noWorkspaces.body": "Bitte einen Admin, dich zu einem Workspace einzuladen.",

  "error.pane": "Diese Unterhaltung kann nicht angezeigt werden.",
  "error.tryAgain": "Erneut versuchen",
  "error.body": "Auf dieser Seite ist ein unerwarteter Fehler aufgetreten.",
  "error.goInbox": "Zum Posteingang",

  "login.title": "Beim Support anmelden",
  "login.sent": "Falls {email} Zugriff hat, ist ein Anmeldelink unterwegs. Er ist 15 Minuten gültig.",
  "login.intro": "Wir senden dir einen einmaligen Anmeldelink per E-Mail.",
  "login.email": "Geschäftliche E-Mail",
  "login.sendFailed": "Der Link konnte nicht gesendet werden. Versuche es in einer Minute erneut.",
  "login.submit": "Link per E-Mail senden",
  "verify.incomplete": "Dieser Link ist unvollständig.",
  "verify.failed": "Anmeldung fehlgeschlagen.",
  "verify.expired": "Link abgelaufen",
  "verify.signingIn": "Du wirst angemeldet…",
  "verify.newLink": "Neuen Link anfordern",

  "newWs.superAdminOnly": "Nur Super-Admins können Workspaces erstellen.",
  "newWs.created": "Workspace erstellt",
  "newWs.copySecret": "Kopiere das Identity-Secret jetzt. Es wird nur einmal angezeigt (du kannst es später neu erzeugen).",
  "newWs.secretLabel": "Identity-Secret (nur Server)",
  "newWs.continue": "Weiter zur Einrichtung",
  "newWs.createFailed": "Workspace konnte nicht erstellt werden",
  "newWs.title": "Neuer Workspace",
  "newWs.intro": "Ein Workspace pro App oder Produkt. Jeder hat sein eigenes Hilfe-Center, seinen Posteingang und seine Schlüssel.",
  "newWs.submit": "Workspace erstellen",

  "reports.period": "Zeitraum",
  "reports.lastDays": "Letzte {count} Tage",
  "reports.loadFailed": "Der Bericht konnte nicht geladen werden.",
  "reports.conversations": "Unterhaltungen",
  "reports.resolved": "Gelöst",
  "reports.medianReply": "Median erste Antwort",
  "reports.satisfaction": "Zufriedenheit",
  "reports.ratingsCount": "{count} Bewertungen",
  "reports.ratingsCount.one": "{count} Bewertung",
  "reports.ratingsCount.other": "{count} Bewertungen",
  "reports.ratings": "Bewertungen",
  "reports.barLabel": "{count} Bewertungen mit {score}",
  "reports.barLabel.one": "{count} Bewertung mit {score}",
  "reports.barLabel.other": "{count} Bewertungen mit {score}",
  "reports.recentComments": "Neueste Kommentare",
  "reports.noComments": "Noch keine Kommentare.",

  "status.open": "Offen",
  "status.pending": "Wartend",
  "status.resolved": "Gelöst",

  "inbox.title": "Support-Posteingang",
  "inbox.conversations": "Unterhaltungen",
  "inbox.liveStopped": "Live-Updates gestoppt.",
  "inbox.notifyPrompt": "Erhalte eine Desktop-Benachrichtigung bei neuen Nachrichten.",
  "inbox.enableNotifications": "Benachrichtigungen aktivieren",
  "inbox.notNow": "Nicht jetzt",
  "inbox.statusFilter": "Status",
  "inbox.assignee": "Zuständig",
  "inbox.all": "Alle",
  "inbox.mine": "Meine",
  "inbox.unassigned": "Nicht zugewiesen",
  "inbox.loadFailed": "Unterhaltungen konnten nicht geladen werden.",
  "inbox.empty.open": "Keine offenen Unterhaltungen 🎉",
  "inbox.empty.pending": "Keine wartenden Unterhaltungen 🎉",
  "inbox.empty.resolved": "Keine gelösten Unterhaltungen 🎉",
  "inbox.you": "Du",
  "inbox.agent": "Agent",
  "inbox.attachment": "📎 Anhang",
  "inbox.unreadCount": "{count} ungelesen",
  "inbox.loadMoreFailed": "Weitere Unterhaltungen konnten nicht geladen werden",
  "inbox.loadMore": "Mehr laden",
  "inbox.select": "Wähle eine Unterhaltung",
  "inbox.visitor": "Besucher {id}",

  "contact.aria": "Kontakt",
  "contact.verified": "✓ Verifizierter Nutzer",
  "contact.anonymous": "Anonymer Besucher",
  "contact.userId": "Nutzer-ID",
  "contact.lastSeen": "Zuletzt gesehen",
  "contact.started": "Begonnen",
  "contact.rating": "Bewertung",

  "event.resolved": "gelöst",
  "event.reopened": "wieder geöffnet",
  "event.assigned": "zugewiesen",
  "event.csat_request": "Bewertung angefragt",
  "event.auto_reply": "automatische Antwort",

  "sys.resolved": "Als gelöst markiert",
  "sys.reopened": "Wieder geöffnet",
  "sys.assigned": "{name} zugewiesen",
  "sys.csat_request": "Bewertung angefragt",
  "sys.auto_reply": "Automatische Antwort: {body}",

  "thread.aria": "Unterhaltung",
  "thread.verified": "Verifizierter Nutzer",
  "thread.you": "{name} (du)",
  "thread.reopen": "Wieder öffnen",
  "thread.snooze": "Zurückstellen",
  "thread.snoozeTitle": "Wartet auf den Kunden",
  "thread.resolve": "Lösen",
  "thread.liveStopped": "Live-Updates für diese Unterhaltung gestoppt.",
  "thread.loadFailed": "Diese Unterhaltung konnte nicht geladen werden.",
  "thread.loadEarlier": "Frühere laden",
  "thread.loadEarlierFailed": "Frühere Nachrichten konnten nicht geladen werden",
  "thread.failedRetry": "Fehlgeschlagen – erneut senden",
  "thread.typing": "{name} schreibt…",
  "thread.seen": "Gesehen",
  "thread.updateFailed": "Aktualisierung fehlgeschlagen",

  "composer.uploadFailed": "Hochladen fehlgeschlagen",
  "composer.savedReplies": "Gespeicherte Antworten",
  "composer.placeholder": "Antwort an {name}… (tippe / für gespeicherte Antworten)",
  "composer.reply": "Antwort",
  "composer.attach": "📎 Anhängen",
  "composer.uploading": "Wird hochgeladen…",
  "composer.removeFile": "{name} entfernen",
  "composer.send": "Senden",

  "faq.untitled": "(ohne Titel)",
  "faq.loadFailed": "Das Hilfe-Center konnte nicht geladen werden.",
  "faq.loadFailedToast": "Das Hilfe-Center konnte nicht geladen werden",
  "faq.notFound": "Artikel nicht gefunden.",
  "faq.backToList": "Zurück zum Hilfe-Center",
  "faq.intro": "Artikel erscheinen im Hilfe-Center der App und werden vorgeschlagen, bevor Kunden einen Chat starten.",
  "faq.newArticle": "Neuer Artikel",
  "faq.categories": "Kategorien",
  "faq.categoriesIntro": "Gruppiere Artikel nach Themen. Titel gibt es pro Sprache.",
  "faq.addCategoryFailed": "Kategorie konnte nicht hinzugefügt werden",
  "faq.newCategoryPlaceholder": "Titel der neuen Kategorie ({locale})",
  "faq.addCategory": "Kategorie hinzufügen",
  "faq.noArticles": "Noch keine Artikel. Beginne mit deiner häufigsten Frage.",
  "faq.uncategorized": "Ohne Kategorie",
  "faq.languages": "Sprachen",
  "faq.views": "Aufrufe",
  "faq.helpful": "Hilfreich",
  "faq.helpfulValue": "{percent} % von {votes}",
  "faq.published": "Veröffentlicht",
  "faq.draft": "Entwurf",
  "faq.missing": "Fehlt",
  "faq.categoryTitle": "Titel ({locale})",
  "faq.saveCategoryFailed": "Kategorie konnte nicht gespeichert werden",
  "faq.categorySaved": "Kategorie gespeichert",
  "faq.deleteCategoryConfirm": "Diese Kategorie löschen? Ihre Artikel sind dann ohne Kategorie.",
  "faq.deleteCategoryFailed": "Kategorie konnte nicht gelöscht werden",
  "faq.addTitleFirst": "Füge zuerst einen Titel hinzu",
  "faq.deleteArticleConfirm": "Diesen Artikel in allen Sprachen löschen?",
  "faq.deleteArticleFailed": "Artikel konnte nicht gelöscht werden",
  "faq.category": "Kategorie",
  "faq.titlePlaceholder": "Wie kann ich…?",
  "faq.untitledExisting": "Füge einen Titel für {locale} hinzu oder entferne unten die Übersetzung {locale}.",
  "faq.untitledNew": "Füge einen Titel für {locale} hinzu oder leere den Text, um diese Sprache wegzulassen.",
  "faq.slug": "URL-Slug",
  "faq.slugHint": "Leer lassen, um ihn aus dem Titel zu erzeugen.",
  "faq.body": "Text (Markdown)",
  "faq.bodyHint": "Unterstützt **fett**, *kursiv*, Listen, Links, Bilder und `Code`. HTML wird als Text angezeigt.",
  "faq.publishedIn": "Veröffentlicht in {locale}",
  "faq.removeTranslation": "Übersetzung {locale} entfernen",
  "faq.preview": "Vorschau",
  "faq.untitledPreview": "Ohne Titel",

  "settings.tab.general": "Allgemein",
  "settings.tab.hours": "Geschäftszeiten",
  "settings.tab.install": "Installation",
  "settings.tab.push": "Push-Benachrichtigungen",
  "settings.tab.team": "Team",
  "settings.tab.canned": "Gespeicherte Antworten",
  "settings.adminOnly": "Nur Workspace-Admins können diese Einstellungen ändern.",
  "settings.loadFailed": "Einstellungen konnten nicht geladen werden.",
  "settings.reloadFailed": "Einstellungen konnten nicht neu geladen werden",

  "general.branding": "Branding",
  "general.brandingIntro": "So sehen Hilfe-Center und Chat in deiner App aus.",
  "general.brandColor": "Markenfarbe",
  "general.brandColorPicker": "Markenfarbe wählen",
  "general.brandColorHex": "Markenfarbe als Hex",
  "general.logoUrl": "Logo-URL",
  "general.logoHint": "HTTPS-Bild oben im Hilfe-Center.",
  "general.languages": "Sprachen",
  "general.languagesIntro": "Die Oberfläche folgt der Gerätesprache, wenn sie hier aktiviert ist; Artikel fallen auf die Standardsprache zurück.",
  "general.defaultLanguage": "Standardsprache",
  "general.greeting": "Begrüßung ({locale})",
  "general.greetingHint": "Leer lassen, um die eingebaute Begrüßung zu verwenden.",
  "general.csatTitle": "Zufriedenheitsbewertungen",
  "general.csatAsk": "Kunden bitten, die Unterhaltung zu bewerten, wenn sie gelöst ist",

  "hours.intro": "Außerhalb dieser Zeiten sehen Kunden, dass du nicht da bist, und erhalten deine automatische Antwort.",
  "hours.enable": "Geschäftszeiten verwenden (sonst wirst du immer als online angezeigt)",
  "hours.timezone": "Zeitzone",
  "hours.open": "Geöffnet",
  "hours.closed": "Geschlossen",
  "hours.opens": "{day} öffnet",
  "hours.closes": "{day} schließt",
  "hours.replyTitle": "Antwortzeit & automatische Antwort",
  "hours.typical": "Übliche Antwortzeit (Minuten)",
  "hours.typicalHint": "Wird Kunden angezeigt, solange du online bist. Leer lassen, um sie auszublenden.",
  "hours.away": "Abwesenheitsnachricht ({locale})",
  "hours.awayHint": "Wird automatisch gesendet, wenn jemand außerhalb der Geschäftszeiten schreibt (höchstens einmal pro 12 Std. pro Unterhaltung).",

  "install.keys": "Schlüssel",
  "install.publishableKey": "Öffentlicher Schlüssel",
  "install.publishableHint": "Darf in deiner App und auf deiner Website stehen.",
  "install.identitySecret": "Identity-Secret",
  "install.secretHint": "Bewahre es auf deinem Server auf. Damit signierst du Nutzer-IDs, sodass Chats mit angemeldeten Nutzern verknüpft sind.",
  "install.secretHidden": "Verborgen. Ein neues Secret macht bestehende Nutzer-Hashes sofort ungültig.",
  "install.rotateConfirm": "Identity-Secret neu erzeugen? Dein Server muss sofort das neue Secret verwenden.",
  "install.rotateFailed": "Secret konnte nicht neu erzeugt werden",
  "install.rotate": "Secret neu erzeugen",
  "install.origins": "Erlaubte Websites",
  "install.originsIntro": "Origins, die das Web-Widget nutzen dürfen (eine pro Zeile, z. B. https://app.example.com). Mit * erlaubst du alle. Mobile Apps brauchen das nicht.",
  "install.saveOrigins": "Origins speichern",
  "install.reactWeb": "React (Web)",
  "install.anyWebsite": "Jede Website",
  "install.verifyUsers": "Nutzer verifizieren (serverseitig)",
  "install.verifyIntro": "Berechne den Nutzer-Hash auf deinem Server und übergib ihn zusammen mit der Nutzer-ID.",

  "push.fcmTitle": "Android (Firebase Cloud Messaging)",
  "push.fcmIntro": "Lade eine Firebase-Dienstkonto-JSON mit der Berechtigung für Cloud Messaging hoch.",
  "push.fcmFile": "Firebase-Dienstkonto-JSON",
  "push.saveFcm": "FCM-Zugangsdaten speichern",
  "push.apnsTitle": "iOS (Apple Push Notification service)",
  "push.apnsIntro": "Erstelle einen APNs-Authentifizierungsschlüssel (.p8) in deinem Apple-Developer-Konto.",
  "push.p8File": ".p8-Schlüsseldatei",
  "push.keyId": "Key-ID",
  "push.teamId": "Team-ID",
  "push.saveApns": "APNs-Zugangsdaten speichern",
  "push.configured": "Eingerichtet am {date}",
  "push.notConfigured": "Nicht eingerichtet",

  "team.invite": "Teammitglied einladen",
  "team.inviteIntro": "Die Person erhält eine E-Mail mit einem Anmeldelink.",
  "team.role": "Rolle",
  "team.role.agent": "Agent",
  "team.role.admin": "Admin",
  "team.sendInvite": "Einladung senden",
  "team.inviteSent": "Einladung gesendet",
  "team.inviteNoEmail": "Hinzugefügt. Keine E-Mail gesendet: Diese Adresse hat kürzlich mehrere Anmelde-E-Mails erhalten. Die Person kann eine davon verwenden.",
  "team.inviteFailed": "Einladung fehlgeschlagen",
  "team.members": "Mitglieder",
  "team.loadFailed": "Mitglieder konnten nicht geladen werden.",
  "team.loadFailedToast": "Mitglieder konnten nicht geladen werden",
  "team.online": "online",
  "team.removeConfirm": "{name} entfernen? Die Unterhaltungen dieser Person sind dann nicht mehr zugewiesen.",
  "team.removeFailed": "Mitglied konnte nicht entfernt werden",

  "canned.intro": "Tippe {shortcut} im Antwortfeld, um eine einzufügen. Verwende {name} für den Vornamen des Kunden und {agent} für deinen.",
  "canned.shortcut": "Kürzel",
  "canned.shortcutHint": "Kleinbuchstaben, Zahlen, Bindestriche",
  "canned.message": "Nachricht",
  "canned.empty": "Noch keine gespeicherten Antworten. Lege eine an und tippe dann ihr /Kürzel im Antwortfeld, um sie einzufügen.",
  "canned.new": "Neue gespeicherte Antwort",
  "canned.deleteConfirm": "Gespeicherte Antwort /{shortcut} löschen?",
  "canned.deleteFailed": "Gespeicherte Antwort konnte nicht gelöscht werden",
  "canned.loadFailed": "Gespeicherte Antworten konnten nicht geladen werden.",
  "canned.loadFailedToast": "Gespeicherte Antworten konnten nicht geladen werden",
};
